/*  Ré‑active le drag Splide sur la galerie produit
    — version ciblant .splide--product                                         */

(function () {
  // Fonction réutilisable (chargement initial + AJAX Shopify)
  function reEnableDrag() {
    document.querySelectorAll('.splide--product').forEach(root => {
      const splide = root.splide;          // instance JS attachée au conteneur
      if (!splide) return;                 // pas encore monté

      if (splide.options.drag === false) { // le thème l’a désactivé
        splide.options = { ...splide.options, drag: true };
        // ré‑active le composant Drag s’il existe
        splide.Components?.Drag?.disable(false);
        splide.refresh();                  // force la prise en compte
        console.debug('[SplideFix] drag ON', root);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', reEnableDrag);
  document.addEventListener('shopify:section:load', reEnableDrag);
})();
